import { c as _slicedToArray, f as _asyncToGenerator } from './_rollupPluginBabelHelpers-fb970440.js';
import React, { useContext, useState, useEffect } from 'react';
import { Modal, useResponsiveParams, Paper, Text, TabList, Grid, SummaryLayout, Card } from 'quanta-ui';
import { Layout, ClientService } from './layout.js';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { a as GET_SELECTED_INTERMEDIARY, G as GET_LOB_PRODUCTLIST, I as IMD_RECEIPT_LOCK, C as CHECK_IMD_CONFIG } from './queries-39e034f7.js';
import { L as Loading } from './loading-c16d3bd3.js';
import { E as Error } from './error-ee5266a9.js';
import { a as ConfigContext } from './ConfigProvider-9522944e.js';
import { i as initIpaQuoteState } from './exports-166cdf01.js';
import { M as ModalTransactionLock } from './modal-transaction-lock-ed4d0501.js';
import { u as useFetchQuery } from './useFetchQuery-56ba5b94.js';
import { I as IntermediaryDetails } from './index-1a574785.js';
import { initBuyHealthPolicyVar } from './proposal/health/state.js';
import { initBuyMotorPolicyVar } from './proposal/motor/state.js';
import { i as initBuyIpaPolicyVar } from './state-cd3cac59.js';
import { i as initBuyWmcPolicyVar } from './state-74edd9f7.js';
import { initMotorQuoteState } from './quote/motor/state.js';
import { initFireQuoteState } from './quote/fire/state.js';
import { initHealthQuoteState, initHealthPlansState } from './quote/health/state.js';
import { i as initMarineVoyageQuoteState } from './state-1fb1e261.js';
import { initShopSecureQuoteState } from './quote/shopsecure/state.js';
import { initWorkmenCompensationQuoteState } from './quote/workmenscompensation/state.js';

function ModalCustomWarning(_ref) {
  var showCustomWarningModal = _ref.showCustomWarningModal,
      setShowCustomWarningModal = _ref.setShowCustomWarningModal,
      customWarningMsg = _ref.customWarningMsg;

  var closeModal = function closeModal() {
    setShowCustomWarningModal(false);
    document.body.classList.remove('overflow-y-hidden');
  };

  return /*#__PURE__*/React.createElement(Modal, {
    display: showCustomWarningModal,
    title: "Warning",
    onClose: function onClose(_) {
      return closeModal();
    },
    severity: 'warning'
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-warning p-2 text-white rounded mb-2"
  }, customWarningMsg)));
}

var renderProductGrid = function renderProductGrid(lob, code, products, quote_products, repeat, showChooseProducts, isConfigImd, selectedIntermediary) {
  var fetchQuery = useFetchQuery();

  var getProductIcon = function getProductIcon(productCode) {
    return quote_products.find(function (product) {
      return product.product_code === productCode;
    }) ? quote_products.find(function (product) {
      return product.product_code === productCode;
    }).icon : quote_products.find(function (product) {
      return product.product_code === '0000';
    }).icon;
  };

  return /*#__PURE__*/React.createElement(Grid, {
    repeat: repeat
  }, products.map(function (prd, idx) {
    var _prd$product_code, _prd$product_code2, _prd$product_code3, _prd$product_code4, _prd$product_code5, _sessionStorage, _sessionStorage$getIt, _prd$product_code6, _prd$product_code7, _prd$product_code8, _prd$product_code9, _prd$product_code10, _prd$product_code11, _prd$product_code12, _prd$product_code13, _prd$product_code14, _prd$product_code15;

    return ((_prd$product_code = prd.product_code) === null || _prd$product_code === void 0 ? void 0 : _prd$product_code.toString()) !== '3151' && ((_prd$product_code2 = prd.product_code) === null || _prd$product_code2 === void 0 ? void 0 : _prd$product_code2.toString()) !== '3176' && ((_prd$product_code3 = prd.product_code) === null || _prd$product_code3 === void 0 ? void 0 : _prd$product_code3.toString()) !== '3140' && ((_prd$product_code4 = prd.product_code) === null || _prd$product_code4 === void 0 ? void 0 : _prd$product_code4.toString()) !== '3184' && ((_prd$product_code5 = prd.product_code) === null || _prd$product_code5 === void 0 ? void 0 : _prd$product_code5.toString()) !== '3129' ? /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: 'relative m-4 flex flex-col justify-start cursor-pointer'
    }, ((_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : (_sessionStorage$getIt = _sessionStorage.getItem('imdReceiptLockStatus')) === null || _sessionStorage$getIt === void 0 ? void 0 : _sessionStorage$getIt.toString()) === 'false' || !showChooseProducts || isConfigImd && (!(selectedIntermediary !== null && selectedIntermediary !== void 0 && selectedIntermediary.fieldUserCode) || !(selectedIntermediary !== null && selectedIntermediary !== void 0 && selectedIntermediary.fieldUserName)) ? /*#__PURE__*/React.createElement(Link, {
      className: "disable-link"
    }, /*#__PURE__*/React.createElement("img", {
      src: getProductIcon(prd.product_code),
      className: "w-full h-full rounded-full flex items-center p-2 mb-2 border-4 border-white hover:border-secondary hover:border-opacity-50 hover:shadow-lg ",
      alt: ((_prd$product_code6 = prd.product_code) === null || _prd$product_code6 === void 0 ? void 0 : _prd$product_code6.toString()) === '3121' ? prd === null || prd === void 0 ? void 0 : prd.display_name : prd.product_name,
      loading: "lazy"
    })) : /*#__PURE__*/React.createElement(Link, {
      to: ((_prd$product_code7 = prd.product_code) === null || _prd$product_code7 === void 0 ? void 0 : _prd$product_code7.toString()) === '3121' ? "/quote/Motor/".concat(code, "/Car Insurance/").concat(prd.product_code) : ((_prd$product_code8 = prd.product_code) === null || _prd$product_code8 === void 0 ? void 0 : _prd$product_code8.toString()) === '3137' ? "/quote/Motor/".concat(code, "/GCV/").concat(prd.product_code) : ((_prd$product_code9 = prd.product_code) === null || _prd$product_code9 === void 0 ? void 0 : _prd$product_code9.toString()) === '3183' ? "/quote/Motor/".concat(code, "/PCV/").concat(prd.product_code) : ((_prd$product_code10 = prd.product_code) === null || _prd$product_code10 === void 0 ? void 0 : _prd$product_code10.toString()) === '3128' ? "/quote/Motor/".concat(code, "/MISCD/").concat(prd.product_code) : "/quote/".concat(lob, "/").concat(code, "/").concat(prd.product_name, "/").concat(prd.product_code),
      onClick: /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_) {
          var _sessionStorage2, _selectedIntermediary2, _sessionStorage3, _selectedIntermediary3, _sessionStorage4, _selectedIntermediary4, _sessionStorage5, _selectedIntermediary5, _sessionStorage6, _selectedIntermediary6, _sessionStorage7, _selectedIntermediary7, getSelectedIntermediary, _yield$getSelectedInt, selectedIntermediaryData, _selectedIntermediary;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  getSelectedIntermediary = fetchQuery({
                    fetchPolicy: 'cache-first',
                    query: GET_SELECTED_INTERMEDIARY
                  });
                  _context.next = 4;
                  return getSelectedIntermediary;

                case 4:
                  _yield$getSelectedInt = _context.sent;
                  selectedIntermediaryData = _yield$getSelectedInt.data;
                  _selectedIntermediary = selectedIntermediaryData.selectedIntermediary;
                  (_sessionStorage2 = sessionStorage) === null || _sessionStorage2 === void 0 ? void 0 : _sessionStorage2.setItem('intermediaryName', _selectedIntermediary === null || _selectedIntermediary === void 0 ? void 0 : (_selectedIntermediary2 = _selectedIntermediary.intermediaryName) === null || _selectedIntermediary2 === void 0 ? void 0 : _selectedIntermediary2.toString());
                  (_sessionStorage3 = sessionStorage) === null || _sessionStorage3 === void 0 ? void 0 : _sessionStorage3.setItem('intermediaryCode', _selectedIntermediary === null || _selectedIntermediary === void 0 ? void 0 : (_selectedIntermediary3 = _selectedIntermediary.intermediaryCode) === null || _selectedIntermediary3 === void 0 ? void 0 : _selectedIntermediary3.toString());
                  (_sessionStorage4 = sessionStorage) === null || _sessionStorage4 === void 0 ? void 0 : _sessionStorage4.setItem('branchOfficeCode', _selectedIntermediary === null || _selectedIntermediary === void 0 ? void 0 : (_selectedIntermediary4 = _selectedIntermediary.branchOfficeCode) === null || _selectedIntermediary4 === void 0 ? void 0 : _selectedIntermediary4.toString());
                  (_sessionStorage5 = sessionStorage) === null || _sessionStorage5 === void 0 ? void 0 : _sessionStorage5.setItem('branchOfficeName', _selectedIntermediary === null || _selectedIntermediary === void 0 ? void 0 : (_selectedIntermediary5 = _selectedIntermediary.branchOfficeName) === null || _selectedIntermediary5 === void 0 ? void 0 : _selectedIntermediary5.toString());
                  (_sessionStorage6 = sessionStorage) === null || _sessionStorage6 === void 0 ? void 0 : _sessionStorage6.setItem('fieldUserCode', _selectedIntermediary === null || _selectedIntermediary === void 0 ? void 0 : (_selectedIntermediary6 = _selectedIntermediary.fieldUserCode) === null || _selectedIntermediary6 === void 0 ? void 0 : _selectedIntermediary6.toString());
                  (_sessionStorage7 = sessionStorage) === null || _sessionStorage7 === void 0 ? void 0 : _sessionStorage7.setItem('fieldUserName', _selectedIntermediary === null || _selectedIntermediary === void 0 ? void 0 : (_selectedIntermediary7 = _selectedIntermediary.fieldUserName) === null || _selectedIntermediary7 === void 0 ? void 0 : _selectedIntermediary7.toString());
                  _context.next = 18;
                  break;

                case 15:
                  _context.prev = 15;
                  _context.t0 = _context["catch"](0);
                  throw _context.t0;

                case 18:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 15]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()
    }, /*#__PURE__*/React.createElement("img", {
      src: getProductIcon(prd.product_code),
      className: "w-full h-full rounded-full flex items-center p-2 mb-2 border-4 border-white hover:border-secondary hover:border-opacity-50 hover:shadow-lg",
      alt: ((_prd$product_code11 = prd.product_code) === null || _prd$product_code11 === void 0 ? void 0 : _prd$product_code11.toString()) === '3121' ? prd === null || prd === void 0 ? void 0 : prd.display_name : prd.product_name,
      loading: "lazy"
    })), /*#__PURE__*/React.createElement("span", {
      className: "pb-4 text-base flex items-center justify-center text-center"
    }, ((_prd$product_code12 = prd.product_code) === null || _prd$product_code12 === void 0 ? void 0 : _prd$product_code12.toString()) === '3121' || ((_prd$product_code13 = prd.product_code) === null || _prd$product_code13 === void 0 ? void 0 : _prd$product_code13.toString()) == '3137' || ((_prd$product_code14 = prd.product_code) === null || _prd$product_code14 === void 0 ? void 0 : _prd$product_code14.toString()) === '3183' || ((_prd$product_code15 = prd.product_code) === null || _prd$product_code15 === void 0 ? void 0 : _prd$product_code15.toString()) === '3128' ? prd === null || prd === void 0 ? void 0 : prd.display_name : prd.product_name)) : null;
  }));
};

var ChooseProductTabList = function ChooseProductTabList(_ref2) {
  var selectedIntermediary = _ref2.selectedIntermediary,
      activeTabIndex = _ref2.activeTabIndex,
      setActiveTabIndex = _ref2.setActiveTabIndex,
      showChooseProducts = _ref2.showChooseProducts;

  var _useContext = useContext(ConfigContext),
      branding = _useContext.branding,
      quote_products = _useContext.quote_products;

  var _useQuery = useQuery(GET_LOB_PRODUCTLIST, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        imdCode: selectedIntermediary.intermediaryCode
      }
    }
  }),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showTransactionLockModal = _useState2[0],
      setShowTransactionLockModal = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showCustomWarningModal = _useState4[0],
      setShowCustomWarningModal = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      customWarningMsg = _useState6[0],
      setCustomWarningMsg = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isConfigImd = _useState8[0],
      setConfigImd = _useState8[1];

  var repeat = useResponsiveParams({
    for_mobile: 2,
    for_desktop: 4
  });

  var _useQuery2 = useQuery(IMD_RECEIPT_LOCK, {
    fetchPolicy: 'cache-and-network',
    variables: {
      intermediaryCode: selectedIntermediary.intermediaryCode
    },
    onCompleted: function onCompleted(data) {
      var _data$getimdReceiptLo;

      var canTransact = data ? data === null || data === void 0 ? void 0 : (_data$getimdReceiptLo = data.getimdReceiptLockStatus) === null || _data$getimdReceiptLo === void 0 ? void 0 : _data$getimdReceiptLo.isAllowed : false;

      if (!canTransact) {
        var _sessionStorage8;

        setShowTransactionLockModal(true);
        (_sessionStorage8 = sessionStorage) === null || _sessionStorage8 === void 0 ? void 0 : _sessionStorage8.setItem('imdReceiptLockStatus', canTransact);
      } else {
        var _sessionStorage9;

        (_sessionStorage9 = sessionStorage) === null || _sessionStorage9 === void 0 ? void 0 : _sessionStorage9.setItem('imdReceiptLockStatus', canTransact);
      }
    }
  }),
      transactionalLoading = _useQuery2.loading;
      _useQuery2.error;
      _useQuery2.data;

  var _useQuery3 = useQuery(CHECK_IMD_CONFIG, {
    fetchPolicy: 'cache-first',
    skip: !selectedIntermediary.intermediaryCode,
    variables: {
      intermediaryCode: selectedIntermediary.intermediaryCode
    },
    onCompleted: function onCompleted(data) {
      var _data$checkConfigImd;

      if (data !== null && data !== void 0 && (_data$checkConfigImd = data.checkConfigImd) !== null && _data$checkConfigImd !== void 0 && _data$checkConfigImd.isConfiguredIMD && (!(selectedIntermediary !== null && selectedIntermediary !== void 0 && selectedIntermediary.fieldUserCode) || !(selectedIntermediary !== null && selectedIntermediary !== void 0 && selectedIntermediary.fieldUserName))) {
        setCustomWarningMsg("Field User is Mandatory.Please select Field User before Proceeding");
        setShowCustomWarningModal(true);
        setConfigImd(true);
      } else {
        setConfigImd(false);
      }
    }
  });
      _useQuery3.loading;
      _useQuery3.error;
      _useQuery3.data;

  if (loading || transactionalLoading) return /*#__PURE__*/React.createElement(Loading, null);
  if (error) return /*#__PURE__*/React.createElement(Error, {
    error: error
  });
  return /*#__PURE__*/React.createElement(Paper, {
    className: "p-2 border border-neutral rounded quanta_paper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(repeat === 2 ? '' : 'pl-4', " pt-2 pb-2")
  }, /*#__PURE__*/React.createElement(Text, {
    type: "title"
  }, "Choose Product")), /*#__PURE__*/React.createElement("div", {
    className: repeat === 2 ? '' : 'pl-4'
  }, /*#__PURE__*/React.createElement(TabList, {
    defaultTabIndex: (activeTabIndex !== null ? activeTabIndex : data.lobProductList.findIndex(function (lob) {
      return branding.selectedLob === lob.lob_name;
    })) < data.lobProductList.filter(function (lob) {
      return lob.products.length > 0;
    }).length ? activeTabIndex !== null ? activeTabIndex : data.lobProductList.findIndex(function (lob) {
      return branding.selectedLob === lob.lob_name;
    }) : 0,
    items: data.lobProductList.filter(function (lob) {
      return lob.products.length > 0;
    }).map(function (lob, idx) {
      return {
        label: lob.lob_name,
        component: function component() {
          return renderProductGrid(lob.lob_name, lob.lob_code, lob.products, quote_products, repeat, showChooseProducts, isConfigImd, selectedIntermediary);
        },
        onTabClick: function onTabClick() {
          return setActiveTabIndex(idx);
        }
      };
    })
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ModalTransactionLock, {
    showTransactionLockModal: showTransactionLockModal,
    setShowTransactionLockModal: setShowTransactionLockModal
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ModalCustomWarning, {
    showCustomWarningModal: showCustomWarningModal,
    setShowCustomWarningModal: setShowCustomWarningModal,
    customWarningMsg: customWarningMsg
  })));
};

function ChooseProduct(_ref3) {
  var activeTabIndex = _ref3.activeTabIndex,
      setActiveTabIndex = _ref3.setActiveTabIndex,
      showChooseProducts = _ref3.showChooseProducts;

  var _useQuery4 = useQuery(GET_SELECTED_INTERMEDIARY, {
    fetchPolicy: 'cache-first'
  }),
      loading = _useQuery4.loading,
      error = _useQuery4.error,
      data = _useQuery4.data;

  if (loading) return /*#__PURE__*/React.createElement(Loading, null);
  if (error) return /*#__PURE__*/React.createElement(Error, {
    error: error
  });
  var selectedIntermediary = data.selectedIntermediary;
  return /*#__PURE__*/React.createElement(ChooseProductTabList, {
    selectedIntermediary: selectedIntermediary,
    activeTabIndex: activeTabIndex,
    setActiveTabIndex: setActiveTabIndex,
    showChooseProducts: showChooseProducts
  });
}

function ProductCampaign() {
  return /*#__PURE__*/React.createElement("div", {
    className: ""
  });
}

function SelectProduct() {
  var _sessionStorage, _sessionStorage$getIt;

  var nav = ['Quote', 'Get Quote'];

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeTabIndex = _useState2[0],
      setActiveTabIndex = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      showChooseProducts = _useState4[0],
      setChooseProducts = _useState4[1];

  useEffect(function () {
    initBuyHealthPolicyVar();
    initBuyMotorPolicyVar();
    initBuyIpaPolicyVar();
    initBuyWmcPolicyVar();
    initMotorQuoteState();
    initFireQuoteState();
    initHealthQuoteState();
    initHealthPlansState();
    initMarineVoyageQuoteState();
    initIpaQuoteState();
    initShopSecureQuoteState();
    initWorkmenCompensationQuoteState();
  }, []);
  return /*#__PURE__*/React.createElement(Layout, {
    nav: nav,
    service_type: ClientService,
    title: "Get a New Quote"
  }, /*#__PURE__*/React.createElement(SummaryLayout, {
    summary: /*#__PURE__*/React.createElement(Card, {
      className: "min-h-screen" //severity="white"
      ,
      title: "What makes us the Best"
    }, /*#__PURE__*/React.createElement(ProductCampaign, null))
  }, ((_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : (_sessionStorage$getIt = _sessionStorage.getItem('imdReceiptLockStatus')) === null || _sessionStorage$getIt === void 0 ? void 0 : _sessionStorage$getIt.toString()) === 'false' ? /*#__PURE__*/React.createElement(Card // severity="error" -- SU Divya not working properly
  , {
    className: "min-h-screen"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-flex-col space-y-3"
  }, /*#__PURE__*/React.createElement(IntermediaryDetails, {
    setChooseProducts: setChooseProducts
  }), /*#__PURE__*/React.createElement(ChooseProduct, {
    activeTabIndex: activeTabIndex,
    setActiveTabIndex: setActiveTabIndex,
    showChooseProducts: showChooseProducts
  }))) : /*#__PURE__*/React.createElement(Card, {
    className: "min-h-screen",
    title: "" //severity="white"

  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-flex-col space-y-3"
  }, /*#__PURE__*/React.createElement(IntermediaryDetails, {
    setChooseProducts: setChooseProducts
  }), /*#__PURE__*/React.createElement(ChooseProduct, {
    activeTabIndex: activeTabIndex,
    setActiveTabIndex: setActiveTabIndex,
    showChooseProducts: showChooseProducts
  })))));
}

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': SelectProduct
});

export { ChooseProduct as C, SelectProduct as S, index as i };
